/* Routes */
export const LOGIN_ROUTE = '/login';
export const WELCOME_PAGE_ROUTE = '/welcome';

export const USERS_ROUTE = '/users';
export const USER_DETAIL_ROUTE = '/user';

export const PROJECTS_ROUTE = '/projects';
export const PROJECT_DETAIL_ROUTE = '/project';
export const CREATE_PROJECT_ROUTE = '/create/project';
export const CHECK_PROJECT_ROUTE = '/check/project';

export const WEB_CHECKS_ROUTE = '/webchecks';
export const WEB_CHECK_DETAIL_ROUTE = '/webcheck';

export const SETTINGS_ROUTE = '/settings';

/* Icons */
// Sidebar
export const PROJECTS_ICON = 'fa-solid fa-file-code';
export const USERS_ICON = 'fa-solid fa-users';
export const CHECKS_ICON = 'fa-solid fa-circle-check';
export const SETTINGS_ICON = 'fa-solid fa-gear';
export const LOGOUT_ICON = 'fa-solid fa-arrow-right-from-bracket';
export const MENU_ICON = 'fa-solid fa-bars fa-lg';
export const CLOSE_ICON = 'fa-solid fa-xmark fa-lg';
// Pages
export const PLUS_ICON = 'fa-solid fa-plus';
export const CHECK_ICON = 'fa-solid fa-circle-check';
export const EDIT_ICON = 'fa-solid fa-pen';
export const DELETE_ICON = 'fa-solid fa-trash';
export const SAVE_ICON = 'fa-solid fa-floppy-disk';
export const START_CHECKS_ICON = 'fa-solid fa-list-check';
export const INFO_ICON = 'fa-solid fa-circle-info';
export const CHANGE_PASSWORD_ICON = 'fa-solid fa-lock';
export const PAGINATION_FORWARD_ICON = '';
export const PAGINATION_BACKWARD_ICON = '';

export const RECORD_NUM_OPTIONS = [
	{ value: 10, name: 10 },
	{ value: 20, name: 20 },
	{ value: 50, name: 50 },
	{ value: 100, name: 100 },
];

export const THEME_OPTIONS = [
	{ value: 'light-mode', name: 'Light-Mode' },
	{ value: 'dark-mode', name: 'Dark-Mode' },
	{ value: 'dark-mode-darker', name: 'Dark-Mode dunkler' },
];

/* Production URLs */
export const CLIENT_BASE_URL = 'https://nikolay-malygin.github.io/web-check-ui-preview';
